import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { FilterDocument } from 'shared/types/filter-document';

export const useUpdateAllTasksFilterDocument = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (filterDocument: Partial<FilterDocument>) =>
      updateSettings({
        filters: {
          allTasks: filterDocument,
        },
      }),
    [updateSettings],
  );
};
